import { createContext, useContext } from 'react';

import noop from 'utils/noop';

import { ExpandModes } from './types';

export type ExpansionState = {
  collapse: () => void;
  expand: () => void;
  mode: ExpandModes;
  reset: () => void;
  toggle: () => void;
};

export const defaultState = {
  collapse: noop,
  expand: noop,
  mode: ExpandModes.off,
  reset: noop,
  toggle: noop,
};

export const ExpansionContext = createContext<ExpansionState>(defaultState);

export const useExpansionContext = () => useContext(ExpansionContext);
